export const UserRoles = Object.freeze({
  SAM_M_ADMIN: "MerchandiserAdmin",
  SAM_M_MANAGER: "MerchandiserManager",
  SAM_M_MERCH: "Merchandiser"
});
